import { render, staticRenderFns } from "./CarrierTaxList.vue?vue&type=template&id=fa33ad56&scoped=true&"
import script from "./CarrierTaxList.vue?vue&type=script&lang=js&"
export * from "./CarrierTaxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa33ad56",
  null
  
)

export default component.exports